import { emptyContact } from './contact';

// Accept legacy exports while resetting fields absent from them to their original defaults.
export function readSettings(text: string) {
    let input: any;
    try { input = JSON.parse(text); } catch { throw new Error('В буфере нет корректного JSON с настройками QRTrace.'); }
    const fail = () => { throw new Error('Настройки QRTrace повреждены или имеют неподдерживаемый формат.'); };
    if (!input || typeof input !== 'object' || typeof input.url !== 'string') fail();
    if (!Number.isFinite(Number(input.qrCodeSize)) || !(Number(input.qrCodeSize) === -1 || Number(input.qrCodeSize) >= 1 && Number(input.qrCodeSize) <= 2000)) fail();
    const styles: any = {};
    const types = {
        backgroundColor: ['rounded'], dotsOptions: ['dots', 'rounded', 'classy', 'classy-rounded', 'square', 'extra-rounded'],
        squareColors: ['', 'none', 'dot', 'square', 'extra-rounded'], dotColors: ['', 'none', 'dot', 'square'],
    };
    Object.entries(types).forEach(([key, allowed]) => {
        const style = input[key];
        const gradient = style?.gradient;
        if (!style || !allowed.includes(style.type) || !['linear', 'radial'].includes(gradient?.type) || !Number.isFinite(gradient.rotation) || !Array.isArray(gradient.colorStops) || gradient.colorStops.length > 100) fail();
        const stops = gradient.colorStops.map(stop => {
            const match = typeof stop.color === 'string' && stop.color.match(/^rgba?\((\d+),(\d+),(\d+)(?:,([\d.]+))?\)$/);
            if (!match || match.slice(1, 4).some(channel => Number(channel) > 255) || (match[4] != null && !(Number(match[4]) >= 0 && Number(match[4]) <= 1)) || !Number.isFinite(stop.offset) || stop.offset < 0 || stop.offset > 1) fail();
            return { offset: stop.offset, color: stop.color };
        });
        styles[key] = { type: style.type, gradient: { type: gradient.type, rotation: gradient.rotation, colorStops: stops.length ? stops : [{ offset: 1, color: 'rgba(0,0,0,0)' }] } };
    });
    const img = input.imageOptions;
    if (!img || !Number.isFinite(img.imageSize) || img.imageSize < 0 || img.imageSize > 1 || !Number.isFinite(img.margin) || img.margin < 0 || img.margin > 500 || typeof img.hideBackgroundDots !== 'boolean') fail();
    const image = (source: any) => {
        if (source == null || source === '') return null;
        if (typeof source !== 'string' || source.length > 16000000 || !/^data:image\/(png|jpeg|jpg|webp|gif|svg\+xml);base64,/.test(source)) fail();
        return source;
    };
    const contact = { ...emptyContact };
    Object.keys(contact).forEach(key => {
        const text = input.contact?.[key] ?? '';
        if (typeof text !== 'string' || text.length > (key === 'website' ? 200 : 100)) fail();
        contact[key] = text;
    });
    if (input.contentType != null && !['url', 'contact'].includes(input.contentType) || input.renderMode != null && !['standard', 'custom', 'art'].includes(input.renderMode) || input.customPattern != null && !['dots', 'diamond', 'bars'].includes(input.customPattern)) fail();
    const artStrength = input.artStrength ?? 80;
    if (!Number.isFinite(artStrength) || artStrength < 10 || artStrength > 100) fail();
    return { ...styles, url: input.url, qrCodeSize: Number(input.qrCodeSize), image: image(input.image),
        imageOptions: { ...img, crossOrigin: 'anonymous' }, contentType: input.contentType ?? 'url', contact,
        renderMode: input.renderMode ?? 'standard', customPattern: input.customPattern ?? 'diamond',
        artwork: image(input.artwork), artworkName: typeof input.artworkName === 'string' ? input.artworkName.slice(0, 200) : '', artStrength };
}
